"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@home-health-notify/domain");
exports.default = {
    type: "VerticalLayout",
    elements: [
        {
            type: "HorizontalLayout",
            elements: [
                {
                    type: domain_1.RenderersUIType.InputWithAdornment,
                    label: "Heart Rate",
                    scope: "#/properties/heartRate",
                    options: {
                        suffix: "/minute",
                    },
                },
                {
                    type: domain_1.RenderersUIType.InputWithAdornment,
                    label: "Blood Pressure (Sitting)",
                    scope: "#/properties/bpSit",
                    options: {
                        suffix: "mmHg",
                    },
                },
                {
                    type: domain_1.RenderersUIType.InputWithAdornment,
                    label: "Blood Pressure (Standing)",
                    scope: "#/properties/bpStand",
                    options: {
                        suffix: "mmHg",
                    },
                },
            ],
        },
        {
            type: "HorizontalLayout",
            elements: [
                {
                    type: domain_1.RenderersUIType.InputWithAdornment,
                    label: "Respiratory Rate",
                    scope: "#/properties/repositoryRate",
                    options: {
                        suffix: "/minute",
                    },
                },
                {
                    type: domain_1.RenderersUIType.InputWithAdornment,
                    label: "Temperature",
                    scope: "#/properties/temperature",
                    options: {
                        suffix: "°F",
                    },
                },
            ],
        },
        {
            type: "HorizontalLayout",
            elements: [
                {
                    type: domain_1.RenderersUIType.InputWithAdornment,
                    label: "Pulse Oximetry",
                    scope: "#/properties/pulseOximetry",
                    options: {
                        suffix: "% O2 Sat",
                    },
                },
                {
                    type: domain_1.RenderersUIType.InputWithAdornment,
                    label: "Pain",
                    scope: "#/properties/pain",
                    options: {
                        suffix: " out of 10",
                    },
                },
            ],
        },
        {
            type: "Control",
            label: "Affected Body Parts",
            scope: "#/properties/location",
        },
        {
            type: "HorizontalLayout",
            elements: [
                {
                    type: "Control",
                    label: "Weight",
                    scope: "#/properties/weight",
                    options: {
                        unitKey: "weightUnit",
                    },
                },
                {
                    type: "Control",
                    scope: "#/properties/weightUnit",
                    label: "",
                    options: {
                        format: "radio",
                        hideInMessage: true,
                    },
                },
            ],
        },
        {
            type: "HorizontalLayout",
            elements: [
                {
                    type: "Control",
                    label: "Sugar",
                    scope: "#/properties/bloodSugar",
                    options: {
                        unit: "mg/dl",
                        unitKey: "bloodSugarType",
                    },
                },
                {
                    type: "Control",
                    scope: "#/properties/bloodSugarType",
                    label: "",
                    options: {
                        format: "radio",
                        hideInMessage: true,
                    },
                },
            ],
        },
        {
            type: "Control",
            label: "Notes",
            scope: "#/properties/notes",
        },
    ],
};
